(function () {
  // Each slider initialises independently so multiple instances on a page
  // don't interfere with each other. Idempotent via data-neyl-vs-ready.

  function initSlider(root) {
    if (root.dataset.neylVsReady === '1') return;
    root.dataset.neylVsReady = '1';

    var viewport = root.querySelector('[data-neyl-vs-viewport]');
    if (!viewport) return;
    var track = viewport.firstElementChild;
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    if (!cards.length) return;

    var prevBtn = root.querySelector('[data-neyl-vs-prev]');
    var nextBtn = root.querySelector('[data-neyl-vs-next]');
    var dotsHost = root.querySelector('[data-neyl-vs-dots]');
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-neyl-vs-video]'));

    var mobileMql = window.matchMedia('(max-width: 767px)');
    function isMobile() { return mobileMql.matches; }

    // ------- Single-video playback policy -------
    // Only one video plays at a time. Calling playOnly() on any video
    // pauses every other video in the same slider.
    function playOnly(video) {
      for (var i = 0; i < videos.length; i++) {
        if (videos[i] !== video) videos[i].pause();
      }
      if (video) {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    }

    function muteAll() {
      videos.forEach(function (v) { v.muted = true; });
      root.querySelectorAll('[data-neyl-vs-mute]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'true');
      });
    }

    // ------- Autoplay on scroll-into-view -------
    // The slider waits until it actually enters the visitor's viewport before
    // starting playback, so a slider far down the page doesn't burn bandwidth
    // before they ever see it. Whichever card is currently the active one
    // (index 0 by default) is the one that plays — so re-entries after a
    // horizontal swipe resume the card the visitor was last on.
    if (!('IntersectionObserver' in window)) {
      // No IO support: fall back to playing the first video on init.
      if (videos.length) playOnly(videos[0]);
    } else {
      var rootIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var v = videos[activeIndex()];
            if (v) playOnly(v);
          }
        });
      }, { root: null, threshold: 0.3 });
      rootIo.observe(root);
    }

    // ------- Click on video container ⇒ toggle play/pause -------
    // Same handler on desktop and mobile. On desktop this is the primary
    // way to start a video (only the first plays on load). On mobile,
    // tapping is also accepted in addition to scroll-driven autoplay.
    cards.forEach(function (card) {
      var media = card.querySelector('[data-neyl-vs-media]');
      var v = card.querySelector('[data-neyl-vs-video]');
      if (!media || !v) return;
      media.addEventListener('click', function (e) {
        // Mute button has its own handler — don't intercept its clicks
        if (e.target.closest('[data-neyl-vs-mute]')) return;
        if (v.paused) {
          playOnly(v);
        } else {
          v.pause();
        }
      });
    });

    // ------- Mute toggle. aria-pressed="true" ⇒ muted, "false" ⇒ unmuted. -------
    // Un-muting one card mutes all the others to avoid stacked audio,
    // and ensures that card is the one playing.
    root.querySelectorAll('[data-neyl-vs-mute]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('.neyl-video-slider__card');
        if (!card) return;
        var v = card.querySelector('[data-neyl-vs-video]');
        if (!v) return;

        var nowMuted = !v.muted;
        if (!nowMuted) {
          videos.forEach(function (other) {
            if (other !== v) {
              other.muted = true;
              var ob = other.closest('.neyl-video-slider__card').querySelector('[data-neyl-vs-mute]');
              if (ob) ob.setAttribute('aria-pressed', 'true');
            }
          });
        }
        v.muted = nowMuted;
        btn.setAttribute('aria-pressed', nowMuted ? 'true' : 'false');
        // Un-muting always implies the user wants to be playing this video
        if (!nowMuted) playOnly(v);
      });
    });

    // ------- Card-step scrolling for prev/next -------
    function cardStep() {
      if (cards.length < 2) return viewport.clientWidth;
      var a = cards[0].getBoundingClientRect();
      var b = cards[1].getBoundingClientRect();
      return b.left - a.left;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    // ------- Active card index + dots -------
    function pageCount() {
      var step = cardStep();
      if (!step) return 1;
      var visible = Math.max(1, Math.round(viewport.clientWidth / step));
      return Math.max(1, cards.length - visible + 1);
    }

    function activeIndex() {
      var step = cardStep();
      if (!step) return 0;
      return Math.round(viewport.scrollLeft / step);
    }

    function buildDots() {
      if (!dotsHost) return;
      dotsHost.innerHTML = '';
      var n = pageCount();
      // If everything fits on one page, hide the whole pager since there's
      // nothing to navigate to.
      var hide = n <= 1;
      if (dotsHost) dotsHost.style.display = hide ? 'none' : '';
      if (prevBtn) prevBtn.style.display = hide ? 'none' : '';
      if (nextBtn) nextBtn.style.display = hide ? 'none' : '';
      if (hide) return;
      for (var i = 0; i < n; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'neyl-video-slider__dot';
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.dataset.index = String(i);
        d.addEventListener('click', (function (idx) {
          return function () {
            viewport.scrollTo({ left: idx * cardStep(), behavior: 'smooth' });
          };
        })(i));
        dotsHost.appendChild(d);
      }
      updateDotState();
    }

    function updateDotState() {
      if (!dotsHost) return;
      var i = activeIndex();
      var dots = dotsHost.children;
      for (var k = 0; k < dots.length; k++) {
        dots[k].classList.toggle('is-active', k === i);
      }
    }

    function updateNavState() {
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      var x = viewport.scrollLeft;
      if (prevBtn) prevBtn.toggleAttribute('disabled', x <= 1);
      if (nextBtn) nextBtn.toggleAttribute('disabled', x >= maxScroll - 1);
    }

    // ------- Mobile: scroll between cards switches active video -------
    // After horizontal scroll settles, on mobile we play whichever card the
    // user has landed on. Audio is reset to muted to match the user's
    // expectation (you tap the speaker icon to enable sound).
    var lastActive = 0;
    function onScrollSettled() {
      updateNavState();
      updateDotState();
      var idx = activeIndex();
      if (idx !== lastActive) {
        lastActive = idx;
        if (isMobile() && videos[idx]) {
          muteAll();
          playOnly(videos[idx]);
        }
      }
    }

    var rafId = null;
    var settleTimer = null;
    viewport.addEventListener('scroll', function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        updateNavState();
        updateDotState();
      });
      clearTimeout(settleTimer);
      settleTimer = setTimeout(onScrollSettled, 120);
    });

    // ------- Pause videos that are entirely off the viewport (perf) -------
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) entry.target.pause();
        });
      }, { root: null, threshold: 0 });
      videos.forEach(function (v) { io.observe(v); });
    }

    function rebuild() {
      buildDots();
      updateNavState();
    }
    rebuild();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(rebuild, 150);
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-neyl-video-slider]');
    for (var i = 0; i < nodes.length; i++) initSlider(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
